import { Button, styled } from "@mui/material";

import { LoadingButton } from "@mui/lab";
import { alpha } from "@mui/material/styles";

export const DatasetButton = styled(Button)(({ theme }) => ({
  border: "1px solid",
  borderColor:
    theme.palette.mode === "light"
      ? "rgba(0, 0, 0, 0.23)"
      : "rgba(255, 255, 255, 0.23)",
  borderRadius: theme.shape.borderRadius,
  textTransform: "none",
  backgroundColor: theme.palette.action.hover,
  color: theme.palette.text.secondary,
  "&:hover": {
    backgroundColor: alpha(theme.palette.primary.main, 0.2),
  },
  "&:focus": {
    borderColor: theme.palette.primary.main,
  },
  "&.Mui-disabled": {
    backgroundColor: theme.palette.action.disabledBackground,
    color: theme.palette.text.disabled,
    borderColor:
      theme.palette.mode === "light"
        ? "rgba(0, 0, 0, 0.12)"
        : "rgba(255, 255, 255, 0.12)",
    // Ensure disabled buttons maintain the same size as enabled ones
    minHeight: "36px", // Standard Material-UI button height
    padding: "6px 16px", // Standard Material-UI button padding
  },
}));

export const DatasetLoadingButton = styled(LoadingButton)(({ theme }) => ({
  border: "1px solid",
  borderColor:
    theme.palette.mode === "light"
      ? "rgba(0, 0, 0, 0.23)"
      : "rgba(255, 255, 255, 0.23)",
  borderRadius: theme.shape.borderRadius,
  textTransform: "none",
  backgroundColor: theme.palette.action.hover,
  color: theme.palette.text.secondary,
  "&:hover": {
    backgroundColor: alpha(theme.palette.primary.main, 0.2),
  },
  "&:focus": {
    borderColor: theme.palette.primary.main,
  },
  "&.Mui-disabled": {
    backgroundColor: theme.palette.action.disabledBackground,
    color: theme.palette.text.disabled,
    borderColor:
      theme.palette.mode === "light"
        ? "rgba(0, 0, 0, 0.12)"
        : "rgba(255, 255, 255, 0.12)",
    // Ensure disabled buttons maintain the same size as enabled ones
    minHeight: "36px", // Standard Material-UI button height
    padding: "6px 16px", // Standard Material-UI button padding
  },
}));
